// extracted by mini-css-extract-plugin
export default {"fixSize":"styles-module__fixSize___ZAYBf","cardError":"styles-module__cardError___Q5I_k"};